module.exports = __webpack_public_path__ + "static/media/mascot-mark.92d68341.svg";